"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.legacyWeatherForecastAlerts = void 0;
const zod_1 = require("zod");
exports.legacyWeatherForecastAlerts = zod_1.z.object({
    alertIds: zod_1.z.array(zod_1.z.string()).optional(),
    includeDeleted: zod_1.z.boolean().default(false).optional(),
    attributes: zod_1.z
        .object({
        alertId: zod_1.z.literal(true).optional(),
        blockIds: zod_1.z.literal(true).optional(),
        createdAt: zod_1.z.literal(true).optional(),
        deletedAt: zod_1.z.literal(true).optional(),
        endDate: zod_1.z.literal(true).optional(),
        name: zod_1.z.literal(true).optional(),
        notifyOwnerByEmail: zod_1.z.literal(true).optional(),
        notifyOwnerBySMS: zod_1.z.literal(true).optional(),
        propertyIds: zod_1.z.literal(true).optional(),
        hourOfDay: zod_1.z.literal(true).optional(),
        startDate: zod_1.z.literal(true).optional(),
        stationGeoms: zod_1.z.literal(true).optional(),
        updatedAt: zod_1.z.literal(true).optional(),
        contacts: zod_1.z
            .object({
            contactId: zod_1.z.literal(true).optional(),
            contactViaEmail: zod_1.z.literal(true).optional(),
            contactViaSMS: zod_1.z.literal(true).optional(),
            email: zod_1.z.literal(true).optional(),
            language: zod_1.z.literal(true).optional(),
            name: zod_1.z.literal(true).optional(),
            sms: zod_1.z.literal(true).optional(),
        })
            .optional()
            .refine((args) => !args || !!Object.keys(args || {}).length, {
            message: "Must request at least one attribute of the alert's contacts",
        }),
        groups: zod_1.z
            .object({
            contactViaEmail: zod_1.z.literal(true).optional(),
            contactViaSMS: zod_1.z.literal(true).optional(),
            groupId: zod_1.z.literal(true).optional(),
            name: zod_1.z.literal(true).optional(),
            contactsForGroup: zod_1.z
                .object({
                contactId: zod_1.z.literal(true).optional(),
                email: zod_1.z.literal(true).optional(),
                language: zod_1.z.literal(true).optional(),
                name: zod_1.z.literal(true).optional(),
                sms: zod_1.z.literal(true).optional(),
            })
                .optional()
                .refine((args) => !args || !!Object.keys(args || {}).length, {
                message: "Must request at least one attribute of the alert's groups' contacts",
            }),
        })
            .optional()
            .refine((args) => !args || !!Object.keys(args || {}).length, {
            message: "Must request at least one attribute of the alert's groups",
        }),
        alertRules: zod_1.z.literal(true).optional(),
    })
        .optional()
        .refine((args) => !args || !!Object.keys(args || {}).length, {
        message: 'Must request at least one attribute for the alert if specifying any at all',
    }),
});
//# sourceMappingURL=legacyWeatherForecastAlerts.js.map